/* Common Imports */

import React from "react";

import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import AmenitiesIconCard from "./subcomponents/AmenitiesIconCard";

/* Data Imports */

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    // /* XXS breakpoint */
    // [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
    //   padding: "0rem 0.5rem 0rem 0.5rem",
    // },
    // [theme.breakpoints.only("xs")]: {
    //   padding: "0rem 1.5rem 0rem 1.5rem",
    // },
    // [theme.breakpoints.only("sm")]: {
    //   padding: "0rem 3rem 0rem 3rem",
    // },
    // [theme.breakpoints.only("md")]: {
    //   padding: "0rem 4rem 0rem 4rem",
    // },
    // [theme.breakpoints.only("lg")]: {
    //   padding: "0rem 4rem 0rem 4rem",
    // },
    // /* XLG breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
    //   padding: "0rem 5rem 0rem 5rem",
    // },
    // /* Full HD breakpoint */
    // [theme.breakpoints.up("xl")]: {
    //   padding: "0rem 23rem 0rem 23rem",
    // },
    // /* XXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
    //   padding: "0rem 36rem 0rem 36rem",
    // },
    // /* XXXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
    //   padding: "0rem 72rem 0rem 72rem",
    // },
    backgroundImage:
      "url(" +
      "/images/icons/heavie/singleproperty/amenities_new.webp" +
      ")",
    backgroundSize: "100% 100%",
    backgroundRepeat: "no-repeat",
    padding: "0rem 8rem 0rem 8rem",
margin: "-0.5rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },

  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      justifyContent: "center",
    },
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    padding: "4rem 0rem 0rem 0rem",
  },
  cardContainer: {
    /* XXS breakpoint */
    // [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
    //   padding: "0rem 0.5rem 0rem 0.5rem",
    // },
    // [theme.breakpoints.only("xs")]: {
    //   padding: "0rem 1.5rem 0rem 1.5rem",
    // },
    // [theme.breakpoints.only("sm")]: {
    //   padding: "0rem 3rem 0rem 3rem",
    // },
    // [theme.breakpoints.only("md")]: {
    //   padding: "0rem 4rem 0rem 4rem",
    // },
    // [theme.breakpoints.only("lg")]: {
    //   padding: "0rem 4rem 0rem 4rem",
    // },
    // /* XLG breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
    //   padding: "0rem 5rem 0rem 5rem",
    // },
    // /* Full HD breakpoint */
    // [theme.breakpoints.up("xl")]: {
    //   padding: "0rem 23rem 0rem 23rem",
    // },
    // /* XXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
    //   padding: "0rem 36rem 0rem 36rem",
    // },
    // /* XXXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
    //   padding: "0rem 72rem 0rem 72rem",
    // },
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",

    flexWrap: "wrap",
    gap: "2rem",
    width: "60%",
    margin: "4rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      gap: "2rem",
      margin: "2rem 0rem 6rem 0rem",
    },
  },
  heading: {
    /* XXS breakpoint */
    // [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
    //   padding: "0rem 0.5rem 0rem 0.5rem",
    // },
    // [theme.breakpoints.only("xs")]: {
    //   padding: "0rem 1.5rem 0rem 1.5rem",
    // },
    // [theme.breakpoints.only("sm")]: {
    //   padding: "0rem 3rem 0rem 3rem",
    // },
    // [theme.breakpoints.only("md")]: {
    //   padding: "0rem 4rem 0rem 4rem",
    // },
    // [theme.breakpoints.only("lg")]: {
    //   padding: "0rem 4rem 0rem 4rem",
    // },
    // /* XLG breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.lg + 48)]: {
    //   padding: "0rem 5rem 0rem 5rem",
    // },
    // /* Full HD breakpoint */
    // [theme.breakpoints.up("xl")]: {
    //   padding: "0rem 23rem 0rem 23rem",
    // },
    // /* XXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
    //   padding: "0rem 36rem 0rem 36rem",
    // },
    // /* XXXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
    //   padding: "0rem 72rem 0rem 72rem",
    // },
    width: "100%",
    color: "#FFFFFF",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.375rem",
      lineHeight: "2.85rem",
    },

  },
  illustrationSizer: {
    width: "100%",
    height: "100%",

    /* XXS breakpoint */
    // [theme.breakpoints.down(theme.breakpoints.values.xs + 280)]: {
    //   height: "280px",
    //   width: "280px",
    // },
    // [theme.breakpoints.only("xs")]: {
    //   height: "320px",
    //   width: "360px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.xs + 94)]: {
    //   height: "380px",
    //   width: "375px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.xs + 109)]: {
    //   height: "380px",
    //   width: "390px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.xs + 131)]: {
    //   height: "400px",
    //   width: "412px",
    // },
    // [theme.breakpoints.only("sm")]: {
    //   height: "700px",
    //   width: "820px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.sm + 168)]: {
    //   height: "720px",
    //   width: "768px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.sm + 220)]: {
    //   height: "730px",
    //   width: "820px",
    // },
    // [theme.breakpoints.only("md")]: {
    //   height: "900px",
    //   width: "1180px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.md + 64)]: {
    //   height: "900px",
    //   width: "1025px",
    // },
    // [theme.breakpoints.up(theme.breakpoints.values.md + 220)]: {
    //   height: "950px",
    //   width: "1180px",
    // },
    // [theme.breakpoints.only("lg")]: {
    //   height: "1200px",
    //   width: "1520px",
    // },
    // [theme.breakpoints.only("xl")]: {
    //   height: "1400px",
    //   width: "1920px",
    // },
    // /* XXL breakpoint */
    // [theme.breakpoints.up(theme.breakpoints.values.xl + 640)]: {
    //   height: "2400px",
    //   width: "2560px",
    // },

    // [theme.breakpoints.up(theme.breakpoints.values.xl + 1920)]: {
    //   height: "3400px",
    //   width: "3840px",
    // },
  },
  amenityCard: {
    width: "25%",
    [theme.breakpoints.down("sm")]: {
      width: "33.3333%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

const Amenities = () => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <div className={classes.megaContainer}>
        <div className={classes.sectionContainer}>
          <Typography className={classes.heading}>Amenities</Typography>
          <div className={classes.cardContainer}>
            <AmenitiesIconCard
              title="Gym"
              icon="/images/icons/heavie/singleproperty/gym.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Yoga Deck"
              icon="/images/icons/heavie/singleproperty/yoga.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Kids Play Area"
              icon="/images/icons/heavie/singleproperty/kids_play_area.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Party Counter"
              icon="/images/icons/heavie/singleproperty/party.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Barbeque Area"
              icon="/images/icons/heavie/singleproperty/barbecue.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Bonfire Area"
              icon="/images/icons/heavie/singleproperty/bonfire.svg"
              className={classes.amenityCard}
            />
            {/* <AmenitiesIconCard
              title="Landscaped Terrace"
              icon="/images/icons/heavie/singleproperty/children_friendly.svg"
              className={classes.amenityCard}
            /> */}
            <AmenitiesIconCard
              title="Infinity pool"
              icon="/images/icons/heavie/singleproperty/swimming.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Meditation Zone"
              icon="/images/icons/heavie/singleproperty/meditation_room.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Kids Pool"
              icon="/images/icons/heavie/singleproperty/kid_pool.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Community Hall"
              icon="/images/icons/heavie/singleproperty/community_hall.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Outdoor Lounge"
              icon="/images/icons/heavie/singleproperty/outdoor_lounge.svg"
              className={classes.amenityCard}
            />
            <AmenitiesIconCard
              title="Security"
              icon="/images/icons/heavie/singleproperty/security.svg"
              className={classes.amenityCard}
            />
          </div>
          {/* <img
            src="/images/icons/heavie/singleproperty/amenities_property.webp"
            alt={AppConfig.imageAltText}
            width={512}
            height={512}
            loading="lazy"
            referrerPolicy="no-referrer"
            className={classes.illustrationSizer}
          /> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Amenities;
